var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutSectionStepIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 10.731,
    y1: 542.633,
    x2: 1072,
    y2: 542.633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#404040"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 541.37,
    cy: 542.63,
    r: 530.63,
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.93 316.09c-57.9-21.57-131.53 6.57-203.57 77.33-72.04-70.76-145.66-98.89-203.57-77.33-44.28 16.5-72.43 60.31-75.31 117.17-2.75 54.48 17.84 115.36 57.99 171.42 46.23 64.55 117.88 122.07 207.29 166.43 4.3 3.54 9.08 5.39 13.6 5.12.2.01.4.01.6.01 4.39 0 8.9-1.75 13-5.14 89.41-44.36 161.06-101.88 207.29-166.43C802.4 548.6 823 487.73 820.24 433.25c-2.87-56.85-31.03-100.66-75.31-117.16zm-396.74 27.89c6.72-2.5 16.86-5.07 30.18-5.07 32.78 0 84.79 15.56 152.26 85.98l10.74 11.21 10.74-11.21c94.88-99.03 159.19-89.56 182.43-80.91 32.8 12.22 53.72 46.16 55.98 90.78.97 19.14-1.26 37.85-5.65 56.15H509.4l-6.67 36.21-30.19-126.81-53.46 110.26H304.46c-9.56-27.55-13.38-53.39-12.25-75.8 2.25-44.63 23.18-78.57 55.98-90.79zm193.17 400.66C419.53 684.29 350.1 608.87 316.84 540.33h120.88l25.18-51.94 43.53 182.83 27.74-150.54h241.27c-37.95 96.9-140.99 177.79-234.08 223.96z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionStepIcon2);
export default __webpack_public_path__ + "static/media/about_section_step_icon_2.43e60d3e1c7b47a072ff1979e2b7361f.svg";
export { ForwardRef as ReactComponent };